export default __webpack_public_path__ + "static/media/dog.ff20b8d6.png";